<template>
    <v-card outlined tile elevation="2">
        <v-card-text>
            <v-form ref="form" style="width: 100%" v-model="valid">
                <div class="d-flex align-center flex-wrap mb-3">
                    <div class="mr-2">
                        <v-text-field
                            v-model="fields.search"
                            @change="changed('search', $event)"
                            append-icon="mdi-magnify"
                            filled
                            label="Buscar"
                            hide-details
                            clearable
                            dense
                            />
                    </div>
                    <div class="mr-2">
                        <SelectorSistemaType
                            label="Tipo de Sistema"
                            @change="changed('sistema_type_id', $event)"
                            v-model="fields.sistema_type_id"
                            :disabled="loading"
                            :loading="loading"
                            />
                    </div>
                </div>
            </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
            <div class="d-flex align-center" style="width: 100%">
                <v-spacer/>
                <v-btn text class="mr-3" :disabled="loading" @click="reset()" small>Reiniciar Filtros</v-btn>
                <v-btn color="primary" :disabled="loading" :loading="loading" @click="search()" small tile><v-icon>mdi-magnify</v-icon>Buscar</v-btn>
            </div>
        </v-card-actions>
    </v-card>
</template>

<script>
import Search from '@mixins/search';

export default {
    props: {
        loading: {},
    },
    mixins: [Search],
    data: function ()  {
        return {
            defaultFields: {
                search: null,
                sistema_type_id: null,
            },
        }
    },
}
</script>

<style>

</style>